import { defineProvider } from '@nuxt/image/runtime'
import { toKonfettiWidth } from '~/utils/mediaHelpers'

/** Max width 910 plus three smaller tiers (only these appear in URLs). */
const WIDTH_RUNGS = [360, 540, 720, 910] as const

function snapToKonfettiWidth(raw: number): number {
  const w = Math.max(1, Math.round(raw))
  for (const rung of WIDTH_RUNGS) {
    if (w <= rung) {
      return rung
    }
  }
  return WIDTH_RUNGS[WIDTH_RUNGS.length - 1]
}

export default defineProvider<{ baseURL?: string }>({
  getImage(src, { modifiers = {}, baseURL = 'https://media.gokonfetti.com/' }) {
    let width = Number(modifiers?.width || 0)
    if (!width || Number.isNaN(width)) {
      width = WIDTH_RUNGS[WIDTH_RUNGS.length - 1]
    }

    width = snapToKonfettiWidth(width)

    const base = baseURL.replace(/\/$/, '')
    return {
      url: toKonfettiWidth(src.trim(), width, base),
    }
  },
})
